import React, { useEffect, useRef, useState } from 'react';
import styles from './orgGuidPackUpload.module.css';
import { useNavigate, useSearchParams } from 'react-router-dom';
import BackIcon from '../../../assets/icons/trvto_ArrowBack.svg';
import ReactLoading from 'react-loading';
import GuidBasic from '../../../components/Guid/orgGuidPackUploadSection/guidBasic/GuidBasic';
import GuidQuickView from '../../../components/Guid/orgGuidPackUploadSection/guidQuickview/GuidQuickView';
import AddTimeSlots from '../../../components/Activity/orgActivityUploadSection/addTimeSlots/AddTimeSlots';
import ItinerarySection from '../../../components/reusable-ui-components/itinerarySection/ItinerarySection';
import ImageUpOrg from '../../../components/packUploadSection/images/ImageUpOrg';
import InEx from '../../../components/packUploadSection/inEx/InEx';
import Safety from '../../orgPackUpload/orgPackUploadSection/safety/safety';
import ThingsToCarry from '../../orgPackUpload/orgPackUploadSection/thingsToCarry/thingsToCarry';
import FAQ from '../../../components/packUploadSection/FAQ/FAQ';
import Terms from '../../orgPackUpload/orgPackUploadSection/terms/Terms';
import Tags from '../../../components/tags/Tags';
import GuidPrice from '../../../components/Guid/orgGuidPackUploadSection/guidPrice/GuidPrice';
import GuidPickup from '../../../components/Guid/orgGuidPackUploadSection/guidPickup/GuidPickup';
import DownArrow from '../../../assets/icons/down-arrow.svg';
import UpArrow from '../../../assets/icons/up-arrow.svg';
import { orgGuidPackUpSubmit } from './orgGuidPackUploadFn/orgGuidPackUploadFn';
import { orgGuidTourFun } from '../../../api/orgGuidAPI';
import errorHandle from '../../../utils/errorHandle';
import GuidMeetup from '../../../components/Guid/orgGuidPackUploadSection/guideMeetup/GuideMeetup';
import PlacesSection from '../../../components/Guid/orgGuidPackUploadSection/guidePlaces/GuidePlaces';

const initialGuidState = {
    _id: '',
    status: '',
    title: '',
    overview: '',
    days: '',
    openTime: '',
    closeTime: '',
    quickView: {
        type: [],
        difficulty: '',
        startTime: '',
        endTime: '',
        duration: '',
        where: '',
        trekDistance: '',
        baseCities: '',
        languages: [],
        maxSlots: '',
        area: ''
    },
    timeSlots: [{ startTime: '', endTime: '', totalSlots: 1 }],
    places: [
        {
            name: '',
            description: ''
        }
    ],
    FAQ: [{ question: '', answer: '' }],
    price: [
        {
            actual: null,
            tax: null,
            total: null,
            reserve: null,
            higherPrice: null,
            discountPer: null,
            perPersonPrice: null,
            name: '',
            terms: '',
            instalments: []
        }
    ],
    pickup: false,
    pickupComment: '',
    meetupLocation: [{ name: '', location: '' }],
    tags: []
};

const OrgGuidPackupload = () => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [scroll, setScroll] = useState(false);
    const basicRef = useRef(null);
    const quickViewRef = useRef(null);
    const itineraryRef = useRef(null);
    const addTimeSlotRef = useRef(null);
    const submitRef = useRef(null);
    const imageRef = useRef(null);
    const placesRef = useRef(null);
    const inExRef = useRef(null);
    const safetyRef = useRef(null);
    const thingsRef = useRef(null);
    const faqRef = useRef(null);
    const termsRef = useRef(null);
    const priceRef = useRef(null);
    const pickupRef = useRef(null);

    const newPack = searchParams.get('new') === 'false';
    const type = searchParams.get('type');
    const guideId = searchParams.get('guideId');

    const [guidData, setGuidData] = useState(initialGuidState);
    const [loading, setLoading] = useState(false);
    const [tempData, setTempData] = useState({
        included: '',
        excluded: '',
        terms: '',
        safety: '',
        carry: ''
    });
    const [imgData, setImgData] = useState({
        oldWallImg: [],
        oldThumbImg: [],
        newWallImg: [],
        newThumbImg: []
    });
    const [isEdit, setIsEdit] = useState(false);
    const [videoFile, setVideoFile] = useState(null);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;

            // Set scroll to true if user is not at top
            if (scrollTop > 3000) {
                setScroll(true);
            } else {
                setScroll(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Clean up on unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    async function fetchPackData(id) {
        try {
            const result = await orgGuidTourFun(id);
            return result.data[0];
        } catch (error) {
            errorHandle(error);
            return null;
        }
    }

    useEffect(() => {
        if (newPack) {
            fetchPackData(guideId).then((data) => {
                setGuidData(data);
                setImgData((prev) => ({
                    ...prev,
                    oldWallImg: data.images,
                    oldThumbImg: data.cardImages
                }));
                setVideoFile(data.videos[0] || null);
                setTempData({
                    included: data.included?.join('\n'),
                    excluded: data.excluded?.join('\n'),
                    terms: data.terms?.join('\n'),
                    safety: data.safety?.join('\n'),
                    carry: data?.carry?.join('\n')
                });
                type === 'duplicate' ? setIsEdit(false) : setIsEdit(true);
                if (type === 'duplicate') {
                    setImgData({
                        oldWallImg: [],
                        oldThumbImg: [],
                        newWallImg: [],
                        newThumbImg: []
                    });
                    setVideoFile(null);
                    setGuidData((prevState) => ({
                        ...prevState,
                        price: initialGuidState.price
                    }));
                }
                setLoading(false);
            });
        } else {
            setLoading(false);
        }
    }, [newPack, guideId, type]);

    const handleSubmit = async () => {
        const response = await orgGuidPackUpSubmit(guidData, tempData, imgData, videoFile, isEdit, setLoading, {
            basicRef,
            imageRef,
            quickViewRef,
            itineraryRef,
            addTimeSlotRef,
            inExRef,
            placesRef,
            safetyRef,
            thingsRef,
            faqRef,
            termsRef,
            priceRef,
            pickupRef
        });
        if (response === 200) {
            navigate('/org/g/my-guide');
        }
    };

    const handleScrollToSubmit = () => {
        if (submitRef.current) {
            submitRef.current.scrollIntoView({ behavior: 'smooth' });
            setScroll(true);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setScroll(false);
    };

    return (
        <div className={styles.orgPackUpDiv}>
            <button className='backBtn' onClick={() => navigate('/org/g/my-guide')}>
                <img src={BackIcon} alt='back' />
                Back to Guide
            </button>
            <div className={styles.orgPackUpDiv}>
                {loading && (
                    <div className='loadingBackground'>
                        <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                        <h3 style={{ marginTop: -100, fontWeight: 700, color: '#9ca3af' }} className='loadingText'>
                            It might take several minutes please wait...
                        </h3>
                    </div>
                )}
                {isEdit && guidData.status === 'active' && (
                    <div className='packEditNote'>
                        <p>
                            <span className='noteSpan'>Note:</span> Since the trip is approved, only certain parts of
                            the data can be edited.
                        </p>
                    </div>
                )}
            </div>
            <div className='sticky-containerPack'>
                {scroll ? (
                    <button onClick={scrollToTop} title='Scroll to bottom' className='sticky-button'>
                        <img src={UpArrow} alt='scroll to bottom' />
                    </button>
                ) : (
                    <button onClick={handleScrollToSubmit} title='Scroll to bottom' className='sticky-button'>
                        <img src={DownArrow} alt='scroll to bottom' />
                    </button>
                )}
            </div>
            <GuidBasic ref={basicRef} guidData={guidData} setGuidData={setGuidData} isEdit={isEdit} />
            <GuidQuickView ref={quickViewRef} guidData={guidData} setGuidData={setGuidData} isEdit={isEdit} />
            <AddTimeSlots
                ref={addTimeSlotRef}
                data={guidData}
                setData={setGuidData}
                dataKey={'guid'}
                title={'Add Time Slots'}
            />
            <PlacesSection
                ref={placesRef}
                data={guidData}
                setData={setGuidData}
                title='Places'
                itemLabel='Place'
                minItems={1}
                isEdit={isEdit}
            />
            <ImageUpOrg
                ref={imageRef}
                imgData={imgData}
                setImgData={setImgData}
                isEdit={isEdit}
                videoFile={videoFile}
                setVideoFile={setVideoFile}
            />
            <InEx ref={inExRef} tempData={tempData} setTempData={setTempData} isEdit={isEdit} packData={guidData} />
            <Safety ref={safetyRef} tempData={tempData} setTempData={setTempData} isEdit={isEdit} packData={guidData} />
            <ThingsToCarry
                ref={thingsRef}
                tempData={tempData}
                setTempData={setTempData}
                isEdit={isEdit}
                packData={guidData}
            />
            <FAQ ref={faqRef} packData={guidData} setPackData={setGuidData} isEdit={isEdit} />
            <Terms ref={termsRef} tempData={tempData} setTempData={setTempData} />
            <GuidPrice ref={priceRef} guidData={guidData} setGuidData={setGuidData} isEdit={isEdit} />
            <GuidMeetup guidData={guidData} setGuidData={setGuidData} />
            <GuidPickup guidData={guidData} setGuidData={setGuidData} isEdit={isEdit} />
            <Tags
                data={guidData}
                setData={setGuidData}
                note={`Topics - “Local Guide”, “Adventure Guide”, “Trekking Guide”, “Mountain Guide”, “Tour Guide”,
                     “Wildlife Guide”, “City Guide”, “Cultural Guide”, “Food Guide”, “Photography Guide”, 
                     “Water Sports Guide”, “Island Guide”, “Beach Guide”, “Hiking Guide”, “Backpacking Guide”, 
                     “Scuba Guide”, “Snorkeling Guide”, “Camping Guide”, “Yoga Guide”, “Meditation Guide”, “Road Trip Guide”,
                     “History Guide”, “Nature Guide”, “Safari Guide”, “Snow Sports Guide”`}
            />
            <button ref={submitRef} type='button' className='orgPackUpSubmitBtn blueBtn' onClick={handleSubmit}>
                Submit
            </button>
        </div>
    );
};

export default OrgGuidPackupload;
